<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <autogestion-log-form ref="form" v-model="form" :input-errors="inputErrors" @save="create" />
    </crud-create>
</template>

<script>

    import AutogestionLogProvider from "../../../../providers/AutogestionLogProvider";
    
    import {CrudCreate, ClientError} from '@dracul/common-frontend'
    
    import AutogestionLogForm from "../../../../forms/AutogestionLogForm";
    
    


    export default {
        name: "AutogestionLogCreate",
         
        components: { AutogestionLogForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'cobrox.autogestionLog.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    identificacion: '',
                    email: '',
                    telefono: '',
                    UserAgent: '',
                    IP: '',
                    Geolocation: '',
                    Referer: '',
                    SO: ''
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    AutogestionLogProvider.createAutogestionLog(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createAutogestionLog)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

